import {ChallengeMode} from "../../../schema";
import {PlayerReduxState} from "../types";
import getCurrentAction from "./getCurrentAction";
import isRecognizing from "./isRecognizing";
import isErrorState from "./isErrorState";
import {isAnyUserInputAction} from "../utils";
import {isUserInputAction} from "../../../types";

export default function canUseHint(state: PlayerReduxState): boolean {
  if (isRecognizing(state) || isErrorState(state)) {
    return false;
  }

  const action = getCurrentAction(state);

  if (!action || !isAnyUserInputAction(action)) {
    return false;
  }

  if (isUserInputAction(action) && action.hintText && !state.exposedActions.includes(action.id)) {
    return true;
  }

  switch (state.challenge.mode) {
    case ChallengeMode.COMPETENCE_TEST:
    case ChallengeMode.CHOICE_BASED_STUDY:
    case ChallengeMode.RPG_MODE:
      break;
    case ChallengeMode.CHOICES_WITH_CUSTOM_SCORES:
    case ChallengeMode.CUSTOM_PARAMETERS_TEST:
      return (state.level !== 1) && !state.exposedActions.includes(action.id);

    default:
      console.warn("canUseHint: unsupported challenge mode");
      return false;
  }
  return false
}
